module.exports = __webpack_public_path__ + "bb2413a3fecd91e0989b020ca6bc4fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/wasistgoldencity3.jpg
// module id = 914
// module chunks = 0